var map = {
	"./de/btn-more.png": "PXtd",
	"./en/btn-more.png": "umWs",
	"./es/btn-more.png": "ra7W",
	"./fr/btn-more.png": "McDG",
	"./ja/btn-more.png": "X+8Y",
	"./ko/btn-more.png": "9KDz",
	"./pt/btn-more.png": "kDDC",
	"./ru/btn-more.png": "THS0",
	"./tc/btn-more.png": "oI/M",
	"./th/btn-more.png": "hzXV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wPgc";